import { defer } from 'lodash';
import { useEffect, useState } from 'react';

const savedPositions = {};

/**
 * Saves and restores the scroll position of an element
 * @param  {ref}    ref               useRef used for the scrolling element
 * @param  {string} key               key used to identify the element
 * @return {number}                   current scroll position
 */
export const useSaveScrollPosition = (ref, key) => {
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        if (!initialized && ref.current && key && savedPositions[key]) {
            const el = ref.current;
            defer(() => {
                el.scrollTop = savedPositions[key];
            });
            setInitialized(true);
        }
    }, [ref.current, key]);

    useEffect(() => {
        if (ref.current && key) {
            let el = ref.current;
            function handleScroll() {
                savedPositions[key] = el.scrollTop;
            }
            el.addEventListener('scroll', handleScroll);
            return () => el.removeEventListener('scroll', handleScroll);
        }
    }, [ref.current, key]);

    return savedPositions[key];
};
